import React, { FunctionComponent, useEffect, useRef, useState } from 'react';
import { Presentation } from './presentation';

type Props = {
  companyId: number;
  recruitmentId: number;
  isConnected: boolean;
  messageBoxId?: number | null;
  isStopped: boolean;
  isLoggedIn: boolean;
  isCompany: boolean;
  isScouted: boolean;
  isShowMag: boolean;
  hideTopEntryButton: boolean;
  handleRegisterModalOpen: () => void;
  handleClickEntry: () => void;
  isPreview: boolean;
  handlePreviewClick: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}
export const Component: FunctionComponent<Props> = ({
  companyId,
  recruitmentId,
  isConnected,
  messageBoxId,
  isStopped,
  isLoggedIn,
  isCompany,
  isScouted,
  isShowMag,
  hideTopEntryButton,
  handleRegisterModalOpen,
  handleClickEntry,
  isPreview,
  handlePreviewClick,
}) => {
  return (
    <Presentation
      companyId={companyId}
      recruitmentId={recruitmentId}
      isConnected={isConnected}
      messageBoxId={messageBoxId}
      isStopped={isStopped}
      isLoggedIn={isLoggedIn}
      isCompany={isCompany}
      isScouted={isScouted}
      isShowMag={isShowMag}
      hideTopEntryButton={hideTopEntryButton}
      handleRegisterModalOpen={handleRegisterModalOpen}
      handleClickEntry={handleClickEntry}
      isPreview={isPreview}
      handlePreviewClick={handlePreviewClick}
    />
  );
};
